
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/about/our-mission",
      function () {
        return require("private-next-pages/[locale]/about/our-mission.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/about/our-mission"])
      });
    }
  